
const job =
{
    Appointments: [
        {
            AppointmentDate: "2022-08-16T11:00:00",
            AppointmentStatus: 2,
            EndTime: "2022-08-16T13:00:00",
            ExchangeUniqueId: null,
            Id: 147,
            JobId: 569,
            Participants: [],
            StartTime: "2021-08-16T11:00:00",
            Subject: null,
            Type: 1,
        },
    ],
    FirstLineComment: "Dette er en firstline comment, Neque porro quisquam est qui dolorem ipsum quia dolor sit amet, ipsum lorem, Neque porro",
    CreatedDate: "2021-08-13T13:43:14.33",
    CustomerComment: "",
    CustomerName: "Firm AS",
    DisplayName: "150 Firm AS",
    Id: 100,
    OrderId: 150,
    IsClosed: false,
    IsMine: false,
    JobPriority: { DueAfterHours: 24, Id: 1, Name: "Today", SortOrder: 1 },
    JobTypeName: "Service",
    Jobs: [
        {
            ClosedDate: null,
            CompletedDate: null,
            CreatedDate: "0001-01-01T00:00:00",
            CustomerCentralSystemId: null,
            CustomerComment: "Customer comment Neque porro quisquam est qui dolorem ipsum quia dolor sit amet,Neque porro quisquam est qui dolorem ipsum quia dolor sit amet, Neque porro quisquam est qui dolorem ipsum quia dolor sit amet, Neque porro quisquam est qui dolorem ipsum quia dolor sit amet, Neque porro quisquam est qui dolorem ipsum quia dolor sit amet",
            CustomerDeliveryAdressCity: null,
            CustomerDeliveryAdressCountry: null,
            CustomerDeliveryAdressName: null,
            CustomerDeliveryAdressStreet: null,
            CustomerDeliveryAdressZip: null,
            CustomerId: null,
            CustomerPerson: null,
            DisplayName: "150 Firm AS",
            EstimatedTime: 0,
            FirstLineComment: null,
            Flag: null,
            HasJobDocuments: false,
            HasSignature: false,
            HazardAnalysis: null,
            Id: 0,
            InvoiceComment: "This is just a test invoice commment; Neque porro quisquam est qui dolorem ipsum quia dolor sit amet; Neque porro quisquam est qui dolorem ipsum quia dolor sit amet, Neque porro quisquam est qui dolorem ipsum quia dolor sit amet,Neque porro quisquam est qui dolorem ipsum quia dolor sit amet",
            IsClosed: false,
            IsParent: false,
            JobCategory: null,
            JobCategoryId: null,
            JobPriority: null,
            JobPriorityId: 0,
            JobStatus: "Planned",
            JobStatusId: 0,
            JobType: null,
            JobTypeId: 0,
            MachineCentralSystemId: null,
            MachineId: null,
            MachineModelId: null,
            MachineName: "Machinename [123456789, 53535353]",
            MaterialRows: null,
            OrderId: 'L150-150',
            PlannedDate: null,
            RepairCodes: null,
            ServiceManagerComment: null,
            ServiceReport: null,
            StartDate: null,
            StartType: null,
            TechnicianComment: null,
            TimeRows: null,
        },
    ],
    OderId: "100",
    StatusId: 10,
    StatusName: "New",
    SubStatusId: null,
    daysAgo: 100,
    odd: 1,
};

export default job;